import { supabase } from '../config/supabaseConfig.ts';

// Atención humana por proyecto (scripts 52 y 55). Solo un admin de plataforma escribe el modo, los roles y las áreas (RLS). Un miembro
// del proyecto sin fila en attention_members cuenta como administrador del proyecto; el equipo con su rol efectivo y su carga sale de
// la RPC attention_team, y su área de attention_members.
const missing = (error, script) => /attention_|does not exist|Could not find|area_id/i.test(error?.message || '') && script;
const fail = (error, what, script = 52) => {
  throw new Error(missing(error, script) ? `Falta correr el script ${script} en Supabase.` : `No se pudo ${what}: ${error.message}`);
};

export const attentionService = {
  async load(projectId) {
    const [settings, team, members, areas] = await Promise.all([
      supabase.from('attention_settings').select('mode').eq('project_id', projectId).maybeSingle(),
      supabase.rpc('attention_team', { p_project: projectId }),
      supabase.from('attention_members').select('cliente_id, area_id').eq('project_id', projectId),
      supabase.from('attention_areas').select('id, name, is_active').eq('project_id', projectId).order('name'),
    ]);
    if (settings.error) fail(settings.error, 'leer el modo de atención');
    if (team.error) fail(team.error, 'leer el equipo del proyecto');
    // Sin el 55 no hay áreas: la pantalla sigue funcionando sin esa parte
    const hasAreas = !areas.error && !members.error;
    const areaOf = new Map((hasAreas ? members.data : []).map((m) => [m.cliente_id, m.area_id]));
    return {
      mode: settings.data?.mode || 'classic',
      team: (team.data || []).map((m) => ({ ...m, area_id: areaOf.get(m.cliente_id) ?? null })),
      areas: hasAreas ? areas.data || [] : null,
    };
  },

  async setMode(projectId, mode) {
    const { error } = await supabase.from('attention_settings').upsert({ project_id: projectId, mode }, { onConflict: 'project_id' });
    if (error) fail(error, 'cambiar el modo de atención');
  },

  /** Rol, si entra al reparto y su área. Crea la fila si el usuario aún no tenía (contaba como administrador). */
  async setMember(projectId, clienteId, { role, isActive, areaId }) {
    const row = { project_id: projectId, cliente_id: clienteId, role, is_active: isActive };
    if (areaId !== undefined) row.area_id = areaId;
    const { error } = await supabase.from('attention_members').upsert(row, { onConflict: 'project_id,cliente_id' });
    if (error) fail(error, 'guardar el usuario', areaId !== undefined ? 55 : 52);
  },

  async createArea(projectId, name) {
    const { error } = await supabase.from('attention_areas').insert({ project_id: projectId, name: name.trim() });
    if (error) {
      if (error.code === '23505') throw new Error(`Ya existe un área «${name.trim()}» en este proyecto.`);
      fail(error, 'crear el área', 55);
    }
  },

  async updateArea(id, patch) {
    const { error } = await supabase.from('attention_areas').update(patch).eq('id', id);
    if (error) {
      if (error.code === '23505') throw new Error('Ya existe un área con ese nombre en este proyecto.');
      fail(error, 'guardar el área', 55);
    }
  },

  /** Borrar un área: sus usuarios quedan sin área y los chats conservan su historial (la base lo hace sola). */
  async deleteArea(id) {
    const { error } = await supabase.from('attention_areas').delete().eq('id', id);
    if (error) fail(error, 'borrar el área', 55);
  },
};
